import {
    fetchImageNames, fetchImageNamesError, fetchImageNamesSuccess
} from '../actions/image.action';
import ImageService from '../api/ImageService';

export const fetchImages = () => async dispatch => {
    dispatch(fetchImageNames());
    try {
        // console.log('dispaching images');
        const files = await ImageService.fetchImageNames();
        // console.log('dispaching success', files);
        dispatch(fetchImageNamesSuccess(files));
    } catch (e) {
        // console.log('dispaching failure', e);
        dispatch(fetchImageNamesError(e.message));
    }
}